module.exports = __webpack_public_path__ + "static/media/PM72.b343b6ec.JPG";